import { MetricsCard } from "../dashboard/metricCards/card1";
import { TransactionWrapper } from "./styles";
import Table from "@/common/components/Table";
import { TableData, TableHeaders, TableKeys } from "./data";
import { ADMIN_TRANSACTIONS } from "@/common/constants";
import useQuery from "@/hooks/useQuery";

import {
  transactionIconGreen,
  transactionIconBlue,
  transactionIconRed,
} from "@/common/components/icons/svg-icons";

export default function DRF_Transactions() {
  const { data } = useQuery(ADMIN_TRANSACTIONS);

  const cardData = [
    {
      value: data?.total_value_processed || 0,
      title: "TOTAL VALUE OF TRANSACTIONS PROCESSED",
      icon: transactionIconGreen,
    },
    {
      value: data?.total_number_of_transactions || 0,
      title: "TOTAL NUMBER OF TRANSACTIONS",
      icon: transactionIconBlue,
    },
    {
      value: data?.total_completed_transactions || 0,
      title: "TOTAL COMPLETED TRANSACTIONS",
      icon: transactionIconGreen,
    },

    {
      value: data?.total_failed_transactions || 0,
      title: "TOTAL FAILED TRANSACTIONS",
      icon: transactionIconRed,
    },
  ];

  return (
    <>
      <TransactionWrapper>
        <div className="cards">
          {cardData.map((datum) => (
            <MetricsCard
              value={datum.value}
              title={datum.title}
              icon={datum.icon}
            />
          ))}
        </div>
        <div className="table">
          <Table
            tableHeaders={TableHeaders}
            tableData={TableData}
            tableKeys={TableKeys}
            tableTitle="Total Transaction"
            dropDownOptions={[
              { label: "Edit", action: (row) => console.log(row) },
              { label: "Delete", action: (row) => console.log(row) },
            ]}
            showDropDown={true}
          />
        </div>
      </TransactionWrapper>
    </>
  );
}
